/**
 * OfflineBanner – unobtrusive connectivity indicator
 *
 * Renders a thin bar at the top of the viewport when the device
 * is offline. Automatically hides when connectivity returns.
 *
 * Usage:
 *   Place once near the top of <App />:
 *     <OfflineBanner />
 */
import { useConnectivity } from '@/hooks/useConnectivity';

export function OfflineBanner() {
  const { isOnline } = useConnectivity();

  if (isOnline) return null;

  return (
    <div
      role="alert"
      className="fixed top-0 inset-x-0 z-[9999] bg-amber-600 text-white text-center text-xs py-1.5 font-medium shadow-md"
    >
      You are offline — changes will sync when connection is restored
    </div>
  );
}
